<template>
    <div class="search-form px-3">
        <div class="col-sm-12 search-form-title">
            <font-awesome-icon icon="search" />
            {{ $t('common.search') }}
        </div>
        <form
            @submit.prevent="onSubmit"
        >
            <div class="row nopads">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t('common.id') }}</span>
                    <input
                        id="id"
                        v-model="bridgeId"
                        class="form-control form-control-sm"
                        type="number"
                        step="any"
                    >
                </div>

                <div class="col-sm-4">
                    <span class="span-title">{{ $t('bridge.name') }}</span>
                    <input
                        id="name"
                        v-model="bridgeName"
                        class="form-control form-control-sm"
                        type="text"
                    >
                </div>

                <div class="col-sm-4">
                    <span class="span-title">{{ $t('bridge.code') }}</span>
                    <input
                        id="code"
                        v-model="bridgeCode"
                        class="form-control form-control-sm"
                    >
                </div>
            </div>
            <div class="col-sm-12 button-container my-2">
                <button
                    type="reset"
                    class="form-button btn btn-danger"
                >
                    {{ $t('ins_report.clear') }}
                </button>
                <button
                    class="form-button btn btn-outline-primary"
                    @click.stop="fetchNearest"
                >
                    {{ $t('bridge.search_nearest') }}
                </button>
                <button
                    type="submit"
                    class="form-button btn btn-primary"
                >
                    {{ $t('ins_report.search') }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>

import {inject} from "vue";

export default {
    name: 'BridgeSearch',
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            bridgeName: null,
            bridgeCode: null,
            bridgeId: null,
        }
    },
    methods: {
        onSubmit: function () {
            let params = {}
            if(this.bridgeName) {
                params.name = this.bridgeName
            }
            if(this.bridgeCode) {
                params.code = this.bridgeCode
            }
            if(this.bridgeId) {
                params.id = this.bridgeId
            }
            this.$emit('search', params)
        },
        fetchNearest: function () {
            if (this.userPosition) {
                this.$emit('search', {
                    lat: this.userPosition.coords.latitude,
                    lon: this.userPosition.coords.longitude
                })
            } else {
                this.showAlert(this.$t('bridge.fetching_location'))
            }
        },
        initPosition: function () {
            navigator.geolocation.getCurrentPosition(pos => this.setPosition(pos))
        },
        setPosition: function (position) {
            this.userPosition = position
        },
        watchUserPosition: function () {
            if (navigator.geolocation) {
                this.watchID = navigator.geolocation.watchPosition(position => {
                    this.setPosition(position)
                }, () => {
                }, {timeout: 30000, enableHighAccuracy: true})
            }
        }
    }
}
</script>
